import type { SVGProps } from "react";
export const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18 9a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-6.75A2.25 2.25 0 0 1 9 18v-6.75A2.25 2.25 0 0 1 11.25 9zm-6.75 1.5a.75.75 0 0 0-.75.75V18c0 .414.336.75.75.75H18a.75.75 0 0 0 .75-.75v-6.75a.75.75 0 0 0-.75-.75z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.75 3.75A2.25 2.25 0 0 1 15 6v.75a.75.75 0 0 1-1.5 0V6a.75.75 0 0 0-.75-.75H6a.75.75 0 0 0-.75.75v6.75a.75.75 0 0 0 .75.75h.75a.75.75 0 0 1 0 1.5H6a2.25 2.25 0 0 1-2.25-2.25V6A2.25 2.25 0 0 1 6 3.75z"
    />
  </svg>
);
